var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0.178223H5C2.23858 0.178223 0 2.4168 0 5.17822V13.1782C0 15.9396 2.23858 18.1782 5 18.1782H13C15.7614 18.1782 18 15.9396 18 13.1782V5.17822C18 2.4168 15.7614 0.178223 13 0.178223ZM16.25 13.1782C16.2445 14.9708 14.7926 16.4227 13 16.4282H5C3.20735 16.4227 1.75549 14.9708 1.75 13.1782V5.17822C1.75549 3.38557 3.20735 1.93371 5 1.92822H13C14.7926 1.93371 16.2445 3.38557 16.25 5.17822V13.1782ZM13.75 5.42822C14.3023 5.42822 14.75 4.9805 14.75 4.42822C14.75 3.87594 14.3023 3.42822 13.75 3.42822C13.1977 3.42822 12.75 3.87594 12.75 4.42822C12.75 4.9805 13.1977 5.42822 13.75 5.42822ZM9 4.67822C6.51472 4.67822 4.5 6.69294 4.5 9.17822C4.5 11.6635 6.51472 13.6782 9 13.6782C11.4853 13.6782 13.5 11.6635 13.5 9.17822C13.5027 7.98392 13.0294 6.83779 12.1849 5.9933C11.3404 5.14881 10.1943 4.67556 9 4.67822ZM6.25 9.17822C6.25 10.697 7.4812 11.9282 9 11.9282C10.5188 11.9282 11.75 10.697 11.75 9.17822C11.75 7.65942 10.5188 6.42822 9 6.42822C7.4812 6.42822 6.25 7.65942 6.25 9.17822Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/IconInstagram.67b188cb37d6ed5f65514bce50931aad.svg";
export { ForwardRef as ReactComponent };